import user from '../helpers/user';
import { isGuestUser, isGuestVisibleCarousel } from '../config/guestMode';

export const filterComponents = (components) => {
    const userInfo = user.getUserInfo();
    const operator = userInfo?.operator;
    const guest = isGuestUser(userInfo);

    const filtered = components?.filter((item) => {
        if (item.excludeForOperators?.includes(operator)) {
            return false;
        }
        if (guest && !isGuestVisibleCarousel(item)) {
            return false;
        }
        return true;
    });

    return filtered;
};
